export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10654.3ebba30e.jpg";